import React, { PureComponent } from 'react'
import { Modal, Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
// import ReactImageZoom from 'react-image-zoom'
import ImageZoom from 'react-image-magnifier-zoom'
import ImgPage from '../../../../../containers/commons/general/ImgPage'
import SmallLoaderPage from '../../../../../containers/commons/SmallLoaderPage'
import InputSelect from '../../../../../components/commons/form/InputSelect'
import InputText from '../../../../../components/commons/form/InputText'
import InputNatural from '../../../../../components/commons/form/InputNatural'
import InputMoney from '../../../../../components/commons/form/InputMoney'
import InputCheckBox from '../../../../../components/commons/form/InputCheckBox'
import InputDatePicker from '../../../../../components/commons/form/InputDatePicker'
import InputDateTimePicker from '../../../../../components/commons/form/InputDateTimePicker'
import SimpleInputText from '../../../../../components/commons/simpleForm/SimpleInputText'
import { typeView as typeViewConstant } from '../../../../../constants/dossier/common/documentTypeView'
import { translateDocumentStatus, documentStatusClass } from '../../../../../constants/dossier/common/documentStatus'
import { typeFields as typeFieldsConstant } from '../../../../../constants/dossier/common/typeFields'
import { dossierTypes as dossierTypesConstant } from '../../../../../constants/dossier/common/dossierTypes'
import { dossierSubTypeId as dossierSubTypeIdConstants } from '../../../../../constants/dossier/common/dossierSubType'
import settings from '../../../../../setting'
import DropZone from 'react-dropzone'
import RejectCommentModal from '../../../../../components/dossierHistorical/common/RejectCommentModal'
import { validateDate, validateRegex, customValidations, getAccepFiles } from '../../../../../util/validationFunctions'
import { multipleNormalize, toUpperCase, trimAll } from '../../../../../util/normalizeFunctions'
import { entityTypesId as entityTypes, backEndIdDocumentStatus } from '../../../../../constants/backendIds'
import TrackingContainer from '../../../../../containers/tracking/trackingContainer'
import { CustomDimensionsConstant } from '../../../../../constants/tracking/CustomDimensionsConstant'
import { TrackingActions } from '../../../../../constants/tracking/TrackingActions'
import PopoverItem from '../../../../../containers/search/PopoverItemPage'
import DossierListPopover from '../../../../../components/search/DossierListPopover'
const averageCharacter = 'c'

class DocumentEdition extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      documentTitle: averageCharacter,
      documentTitleCharWidth: null,
      documentTitleCharLimit: null,
      showTitle: false,
      files: [],
      selectedDocType: null,
      showRejectCommentModal: false,
      hasNewDocument: false,
      showFileUploader: false,
      showSheets: false,
      showMissingDocumentTypeError: false,
      hasInvalidFile: false,
      showDocumentCarrusel: false,
      autoCloseDocumentCarrusel: false,
      isDocumentCarruselEndReached: false,
      showPageCarrusel: true,
      autoClosePageCarrusel: false,
      force: true,
      zoomProps: {
        width: 0,
        height: 0,
        zoomWidth: 0,
        scale: 0.9,
        img: '',
        offset: { vertical: 0, horizontal: 10 },
        zoomPosition: 'original'
      },
      hasDropzoneImg: false,
      parametroFecha: Date.now(),
      dropzoneActive: false,
      dropzonePanelActive: false,
      carouselItemsPerPage: 20,
      carouselPaginationIdx: 1,
      dossierDataGroupDATAOpen: true,
      dossierDataGroupFILESOpen: true,
      dossierDataGroupMETAOpen: true,
      dossierDataGroupFIELSSOpen: true,
      dossierDataGroupACTIONSOpen: true,
      dossierDataGroupOBSERVATIONSOpen: true
    }
    this.toggleFullScreenDocumentModal.bind(this)
    this.toggleFullScreenDocumentSheetModal.bind(this)
    this.deleteDocumentSheet.bind(this)
    this.cancelDocument.bind(this)
    this.setActivePage.bind(this)
    this.updateImgSize.bind(this)
    this.closeModal.bind(this)
    this.onDragEnter.bind(this)
    this.onDragLeave.bind(this)
    this.rejectDocument = this.rejectDocument.bind(this)
    this.documentTitleElementRef = React.createRef()
    // this.documentTitleElementRef = null
    // this.setDocumentTitleElementRef = element => {
    //   this.documentTitleElementRef = element
    // }
  }

  toggleDossierDataGroup (DataGroup) {
    switch (DataGroup) {
      case 'DATA': /* DataGroup_DATA */
      { this.setState({ dossierDataGroupDATAOpen: !this.state.dossierDataGroupDATAOpen })
        break }
      case 'FILES': /* DataGroup_FILES */
      { this.setState({ dossierDataGroupFILESOpen: !this.state.dossierDataGroupFILESOpen })
        break }
      case 'META': /* DataGroup_META */
      { this.setState({ dossierDataGroupMETAOpen: !this.state.dossierDataGroupMETAOpen })
        break }
      case 'FIELS': /* DataGroup_FIELS */
      { this.setState({ dossierDataGroupFIELSSOpen: !this.state.dossierDataGroupFIELSSOpen })
        break }
      case 'ACTIONS': /* DataGroup_ACTIONS */
      { this.setState({ dossierDataGroupACTIONSOpen: !this.state.dossierDataGroupACTIONSOpen })
        break }
      case 'OBSERVATIONS': /* DataGroup_ACTIONS */
      { this.setState({ dossierDataGroupOBSERVATIONSOpen: !this.state.dossierDataGroupOBSERVATIONSOpen })
        break }
    }
  }

  updateBaseTrackingAction () {
    this.baseTrackingAction = {
      href: window.location.href,
      documentTitle: this.props.dossierType + 'Historical_page',
      organizedUnitId: this.props.organizedUnitId,
      category: (this.props.dossierType === '' || !this.props.dossierType) ? '-' : this.props.dossierType,
      customDimensions: [
        { id: CustomDimensionsConstant.DOCUMENT_TYPE_ID, value: this.props.documentTypeId },
        { id: CustomDimensionsConstant.DOCUMENT_TYPE_USE_ID, value: this.props.documentTypeUseId },
        { id: CustomDimensionsConstant.DOCUMENT_TYPE_USE_NAME, value: this.props.documentTypeUseName }
      ]
    }
  }

  // La subida, validación, anulación, solicitud de firma, subida de hojas, borrado de hojas, apertura de la modal de documentos. Añadir información del documento si es posible.

  factoryOpenDocumentModalAction (dossierType, organizedUnitId, documentTypeUseId, documentTypeUseName) {
    this.updateBaseTrackingAction()
    var documentTypeuseDimension = this.baseTrackingAction.customDimensions.filter(x => x.id === CustomDimensionsConstant.DOCUMENT_TYPE_USE_ID)
    documentTypeuseDimension[0].value = documentTypeUseId

    dossierType = (dossierType === '' || !dossierType) ? '-' : dossierType

    var documentTypeuseNameDimension = this.baseTrackingAction.customDimensions.filter(x => x.id === CustomDimensionsConstant.DOCUMENT_TYPE_USE_NAME)
    documentTypeuseNameDimension[0].value = documentTypeUseName
    return { ...this.baseTrackingAction, action: TrackingActions.OPEN_DOCUMENT_MODAL, category: dossierType, organizedUnitId: organizedUnitId }
  }

  factoryCreateDocumentAction (documentType) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.CREATE_DOCUMENT }
  }

  factoryCreateDocumentSheetAction (file, documentId) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.CREATE_DOCUMENT_SHEET }
  }

  factoryValidateDocumentAction (documentId) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.VALIDATE_DOCUMENT }
  }

  factorycancelDocumentAction (documentId) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.CANCEL_DOCUMENT }
  }

  factorySignRequestAction (documentId) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.SIGN_REQUEST }
  }

  factoryDeleteSheetAction (documentId) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.DELETE_SHEET }
  }

  factorySaveDocumentAction (documentType) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.SAVE_DOCUMENT }
  }

  factoryRejectDocumentAction (documentType) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.REJECT_DOCUMENT }
  }

  closeModal () {
    this.props.actions.closeAddOrEditDocumentModal(this.state.hasNewDocument)
    this.setState({
      documentTitle: averageCharacter,
      documentTitleCharWidth: null,
      documentTitleCharLimit: null,
      showTitle: false,
      files: [],
      selectedDocType: null,
      hasNewDocument: false,
      showFileUploader: false,
      showSheets: false,
      showMissingDocumentTypeError: false,
      hasInvalidFile: false,
      zoomProps: { ...this.state.zoomProps, width: 0, height: 0, zoomWidth: 0, img: '' },
      hasDropzoneImg: false,
      showDocumentCarrusel: false,
      isDocumentCarruselEndReached: false,
      showPageCarrusel: true,
      dropzoneActive: false,
      dropzonePanelActive: false,
      carouselPaginationIdx: 1
    })
    this.props.initialize({})
  }

  onDrop (fileToUpload, rejectedFiles, organizedUnitId) {
    if (fileToUpload.length === 0 && rejectedFiles.length > 0) {
      this.setState({ hasInvalidFile: true })
    } else {
      this.setState({ files: [fileToUpload[0]], hasNewDocument: true, hasInvalidFile: false })
      if (fileToUpload[0]) {
        if (this.props.docResult.documentId) {
          this.props.actions.createDocumentSheet(fileToUpload[0], organizedUnitId)
          this.props.trackAction(this.factoryCreateDocumentSheetAction(fileToUpload[0], this.props.docResult.documentId))
        } else {
          this.props.actions.createDocument(fileToUpload[0], this.props.checklistId, this.props.documentTypeUseId || this.state.selectedDocType, this.props.dossierId)
          this.props.trackAction(this.factoryCreateDocumentAction(this.state.selectedDocType))
        }
      }
    }
  }

  onDragEnter (panel = false) {
    this.setState(panel ? { dropzonePanelActive: true } : { dropzoneActive: true })
  }

  onDragLeave (panel = false) {
    this.setState(panel ? { dropzonePanelActive: false } : { dropzoneActive: false })
  }

  changeAll (values) {
    Object.keys(values.entityValue).map(value => {
      this.props.change('AddOrEditHistoricalDocumentForm', `entityValue.${value}`, values.entityValue[value])
    })
  }

  submitDocument (values) {
    const errors = validateFunction(values, this.props)
    if (errors.entityValue && Object.keys(errors.entityValue || {}).length !== 0) return
    const valuesInFields = this.props.docResult.fields.map(field => {
      return {
        ...field, entityValue: values.entityValue[field.fieldId]
      }
    })
    if (values.validateAction) {
      this.props.actions.validateDocument(this.props.docResult.documentId, valuesInFields)
      this.props.trackAction(this.factoryValidateDocumentAction(this.props.docResult.documentId))
    } else {
      this.props.actions.saveDocument(valuesInFields)
      this.props.trackAction(this.factorySaveDocumentAction())
    }
  }

  handleDocTypeChange (documentTypeId) {
    const documentType = this.props.combos.documentsTypes.find((documentsType) => documentsType.id === documentTypeId)
    if (!documentTypeId) this.setState({ files: [] })
    this.setState({ selectedDocType: documentTypeId, showMissingDocumentTypeError: !documentTypeId })
    this.props.actions.onDocumentTypeIdChange(documentTypeId, documentType.value)
  }

  copyMetaToEntityValues () {
    this.props.docResult.fields.forEach(field => {
      this.props.change(`entityValue.${field.fieldId}`, field.metaValue || '')
    })
  }

  uploadNewVersion () {
    this.setState({ hasNewDocument: true })
    this.props.docResult.fields.forEach(field => {
      this.props.change(`entityValue.${field.fieldId}`, '')
    })
    this.props.actions.uploadNewVersion()
  }

  rejectDocument (values, resolve, reject) {
    this.props.actions.rejectDocument(this.props.docResult.documentId, values, resolve, reject)
    this.props.trackAction(this.factoryRejectDocumentAction())
  }

  toggleFullScreenDocumentModal (e) {
    e.stopPropagation()
    this.props.actions.toggleFullScreenDocumentModal(this.props.docResult.documentId)
  }

  downloadDocument (e) {
    e.stopPropagation()
    this.props.actions.toggleFullScreenDocumentModal(this.props.docResult.documentId, true)
  }

  toggleFullScreenDocumentSheetModal (e, sheetId) {
    e.stopPropagation()
    this.props.actions.toggleFullScreenDocumentSheetModal(this.props.docResult.documentId, sheetId)
  }

  downloadDocumentSheet (e, sheetId) {
    e.stopPropagation()
    this.props.actions.toggleFullScreenDocumentSheetModal(this.props.docResult.documentId, sheetId, true)
  }

  deleteDocumentSheet (e, sheetId, organizedUnitId) {
    e.stopPropagation()
    this.setActivePage(0, 1)
    new Promise((resolve, reject) => {
      var deleteDocumentSheetresult = this.props.actions.deleteDocumentSheet(this.props.docResult.documentId, sheetId, resolve, reject, organizedUnitId)
      this.props.trackAction(this.factoryDeleteSheetAction(this.props.docResult.documentId))
      return deleteDocumentSheetresult
    }).then(() => {
      const currentDate = Date.now()
      this.setState({
        parametroFecha: currentDate,
        zoomProps: {
          ...this.state.zoomProps,
          img: `${settings.url}documentHistorical/${this.props.docResult.documentId}/${this.props.activeSheet !== 0 ? `sheet/${this.props.activeSheet}/` : ''}preview?token=${this.props.token}&fecha=${currentDate}`
        }
      })
    })
  }

  getDocumentTitle (props) {
    const tKey = 'DOSSIER_COMPONENTS.DOCUMENTARY_MANAGEMENT.ADD_OR_EDIT_DOCUMENT.'
    return (props.docResult.documentId ? props.t(`${tKey}EDIT`) : props.t(`${tKey}ADD`)) + (props.documentTypeUseName ? (' - ' + props.documentTypeUseName) : '')
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (this.props.showDocumentEditionModal && !nextProps.showDocumentEditionModal) {
      this.setState({
        documentTitle: averageCharacter,
        documentTitleCharWidth: null,
        documentTitleCharLimit: null,
        showTitle: false,
        files: [],
        selectedDocType: null,
        dropzoneActive: false,
        dropzonePanelActive: false,
        carouselPaginationIdx: 1
      })
    }
    if (!this.props.showDocumentEditionModal && nextProps.showDocumentEditionModal) {
      nextProps.actions.setWindowDimensions(nextProps.windowWidth - 100, nextProps.windowHeight)
      window.setTimeout(() => nextProps.actions.setWindowDimensions(nextProps.windowWidth, nextProps.windowHeight), 100)
      this.props.trackAction(this.factoryOpenDocumentModalAction(nextProps.dossierType, nextProps.organizedUnitId, nextProps.documentTypeUseId, nextProps.documentTypeUseName))
    }
    if (nextProps.docResult && nextProps.docResult.documentId &&
      (
        this.props.docResult.documentId !== nextProps.docResult.documentId ||
        this.props.activeSheet !== nextProps.activeSheet ||
        this.props.activePage !== nextProps.activePage
      )
    ) {
      this.setState({
        zoomProps: {
          ...this.state.zoomProps,
          img: `${settings.url}documentHistorical/${nextProps.docResult.documentId}/${nextProps.activeSheet !== 0 ? `sheet/${nextProps.activeSheet}/` : ''}preview?token=${nextProps.token}${nextProps.activePage && '&pageId=' + nextProps.activePage}&fecha=${this.state.parametroFecha}`
        }
      })
    }
    if (nextProps.docResult.fields !== this.props.docResult.fields) {
      const fields = { entityValue: {}, metaValue: {} }
      nextProps.docResult.fields && nextProps.docResult.fields.length && nextProps.docResult.fields.forEach(field => {
        fields.entityValue[field.fieldId] = field.entityValue
        fields.metaValue[field.fieldId] = field.metaValue
      })
      fields.documentType = nextProps.docResult.documentTypeId
      fields.comment = nextProps.docResult.comment
      this.props.initialize(fields)
    }
    if (nextProps.docResult.sheets.length !== this.props.docResult.sheets.length) {
      this.setState({ showSheets: nextProps.docResult.sheets.length > 0 })
    }
    if (nextProps.docResult.documentId !== this.props.docResult.documentId || !nextProps.docResult.documentId) {
      this.setState({ showFileUploader: !nextProps.docResult.documentId })
    }
    if ((!this.props.showDocumentEditionModal && nextProps.showDocumentEditionModal) ||
      nextProps.docResult.fields !== this.props.docResult.fields ||
      this.props.activeSheet !== nextProps.activeSheet) {
      this.setState({ showPageCarrusel: nextProps.docResult.numPages && (nextProps.activeSheet === 0 ? nextProps.docResult.numPages : nextProps.docResult.sheets.find((e) => e.id === nextProps.activeSheet).numPages) > 1 })
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.showDocumentEditionModal && this.props.docResult) {
      if (this.state.documentTitleCharWidth === null && this.documentTitleElementRef && this.documentTitleElementRef.current && this.state.documentTitle === averageCharacter) {
        this.setState({
          documentTitle: averageCharacter.repeat(19),
          documentTitleCharWidth: this.documentTitleElementRef.current.offsetWidth
        })
      }

      if (this.state.documentTitleCharLimit === null && this.documentTitleElementRef && this.documentTitleElementRef.current && this.state.documentTitle === averageCharacter.repeat(19)) {
        this.setState({
          documentTitleCharLimit: Math.floor(this.documentTitleElementRef.current.offsetWidth / this.state.documentTitleCharWidth * 2)
        })
      }

      if ((this.state.documentTitleCharLimit !== null && this.state.documentTitle === averageCharacter.repeat(19))) {
        let documentTitle = this.getDocumentTitle(this.props)
        if (documentTitle.length > this.state.documentTitleCharLimit) {
          documentTitle = documentTitle.substring(0, this.state.documentTitleCharLimit) + '...'
        }
        this.setState({ documentTitle, showTitle: true })
      }
    }
    const dropzoneImg = document.querySelector('.dropzone-img-wrapper > div img')
    if (this.state.zoomProps.img && this.props.windowWidth !== 0 && this.props.windowHeight !== 0 &&
      (
        (!this.state.hasDropzoneImg && dropzoneImg) ||
        this.state.zoomProps.img !== prevState.zoomProps.img ||
        this.state.showPageCarrusel !== prevState.showPageCarrusel ||
        this.props.windowWidth !== prevProps.windowWidth || this.props.windowHeight !== prevProps.windowHeight
      )
    ) {
      if (dropzoneImg) {
        if (this.state.zoomProps.img === prevState.zoomProps.img && dropzoneImg.naturalWidth > 0) {
          this.updateImgSize(dropzoneImg)
        } else {
          if (dropzoneImg.naturalWidth > 0) {
            dropzoneImg.src = ''
            dropzoneImg.src = this.state.zoomProps.img
          }
          dropzoneImg.addEventListener('load', (e) => {
            this.updateImgSize(e.currentTarget)
          })
        }
      }
      if (this.state.hasDropzoneImg !== !!dropzoneImg) this.setState({ hasDropzoneImg: !!dropzoneImg })
    }
  }

  toggleDocumentCarrusel () {
    this.setState({
      showDocumentCarrusel: !this.state.showDocumentCarrusel
    })
  }

  togglePageCarrusel () {
    this.setState({
      showPageCarrusel: !this.state.showPageCarrusel
    })
  }

  toggleCloud () {
    this.setState({
      showDocumentCarrusel: true
    })
  }

  setActivePage (sheetId, pageId) {
    if (this.props.activeSheet !== sheetId) {
      this.setState({ autoCloseDocumentCarrusel: true })
    } else if (this.props.activePage !== pageId) {
      this.setState({ autoClosePageCarrusel: true })
    }
    this.props.actions.setActivePage(sheetId, pageId)
  }

  fileCarruselMouseLeave () {
    if (this.state.autoCloseDocumentCarrusel) {
      this.setState({ autoCloseDocumentCarrusel: false })
      this.toggleDocumentCarrusel()
    }
  }

  pageCarruselMouseLeave () {
    if (this.state.autoClosePageCarrusel) {
      this.setState({ autoClosePageCarrusel: false })
      this.togglePageCarrusel()
    }
  }

  scrollToFile (side = 1) {
    const initialScrollPosition = this.refs.horizontalScrollWrapper.scrollTop
    const thumbnailWidth = 215
    let allowedMovement = (this.state.isDocumentCarruselEndReached || thumbnailWidth)
    if (allowedMovement < thumbnailWidth / 2) allowedMovement += thumbnailWidth
    const totalTimePerStep = 100
    const distancePerInterval = Math.round(allowedMovement / totalTimePerStep) * side
    let currentDistance = 0
    let lastScroll

    const interval = window.setInterval(() => {
      lastScroll = this.refs.horizontalScrollWrapper.scrollTop
      currentDistance += distancePerInterval
      this.refs.horizontalScrollWrapper.scrollTop += distancePerInterval
      if ((currentDistance * side) >= allowedMovement || lastScroll === this.refs.horizontalScrollWrapper.scrollTop) {
        if (this.state.isDocumentCarruselEndReached) {
          this.setState({ isDocumentCarruselEndReached: false })
        } else if (Math.abs(initialScrollPosition - this.refs.horizontalScrollWrapper.scrollTop) < allowedMovement) {
          this.setState({ isDocumentCarruselEndReached: Math.abs(initialScrollPosition - this.refs.horizontalScrollWrapper.scrollTop) })
        }
        window.clearInterval(interval)
      }
    }, totalTimePerStep / allowedMovement)
  }

  cancelDocument (dossierType, documentId, documentParentTypeId, dossierId) {
    new Promise((resolve, reject) => {
      var cancelDocumetResult = this.props.actions.cancelDocument(dossierType, documentId, documentParentTypeId, dossierId, resolve, reject)
      this.props.trackAction(this.factorycancelDocumentAction(documentId))
      return cancelDocumetResult
    }).then(() => {
      this.closeModal()
    })
  }

  updateImgSize (dropzoneImg) {
    const allowWidth = this.props.windowWidth / 2 - (this.state.showPageCarrusel ? 120 : 60) - 20
    const allowHeight = this.props.windowHeight - 80 - 140
    let percentToReduce = 1
    if (dropzoneImg.naturalWidth > allowWidth) {
      percentToReduce = Math.min(percentToReduce, (allowWidth / dropzoneImg.naturalWidth))
    }
    if (dropzoneImg.naturalHeight > allowHeight) {
      percentToReduce = Math.min(percentToReduce, (allowHeight / dropzoneImg.naturalHeight))
    }
    if (percentToReduce < 1) {
      this.setState({
        zoomProps: {
          ...this.state.zoomProps,
          width: parseInt(dropzoneImg.naturalWidth * percentToReduce),
          height: dropzoneImg.naturalHeight * percentToReduce,
          zoomWidth: dropzoneImg.naturalWidth * percentToReduce
        }
      })
    } else {
      this.setState({
        zoomProps: {
          ...this.state.zoomProps,
          width: parseInt(dropzoneImg.naturalWidth),
          height: dropzoneImg.naturalHeight,
          zoomWidth: dropzoneImg.naturalWidth
        }
      })
    }
  }

  nextCarouselPage (val) {
    let carouselPaginationIdx = 0
    if (val === -1) {
      carouselPaginationIdx = this.state.carouselPaginationIdx - 1 === 0 ? 1 : this.state.carouselPaginationIdx - 1
    } else {
      carouselPaginationIdx = this.state.carouselPaginationIdx ? this.state.carouselPaginationIdx + 1 : 2
    }

    let activeSheetIdx = 0
    if (this.props.docResult && this.props.docResult.sheets && this.props.activeSheet) {
      activeSheetIdx = this.props.docResult.sheets.findIndex((sheet, idx) => {
        return this.props.activeSheet === sheet.id
      })
    }

    const initItem = carouselPaginationIdx > 1 ? (carouselPaginationIdx - 1) * this.state.carouselItemsPerPage + 1 : 1

    this.setActivePage(activeSheetIdx, initItem)
    this.setState({ carouselPaginationIdx: carouselPaginationIdx })
  }

  selectDocument (sheetId, pageId) {
    this.setActivePage(sheetId, pageId)
    this.setState({ carouselPaginationIdx: 1 })
  }

  render () {
    const {
      t, showDocumentEditionModal, handleSubmit, documentTypeUseName, token,
      documentTypeUseId, documentParentTypeId, dossierId, entityId, vehicleId, organizedUnitId, callback,
      refreshAfterChange, dossierType, dossierSubType, checkListIdReciboPagaYSenal, activeSheet, /* activePage, */ readOnlyFields,
      docResult: {
        documentId, typeView, documentStatusId, thumbnail,
        fields = [], comment, incorporationDate, sheets, numPages = 1, data, typeObject
      },
      actions: {
        openDocumentEditionModal,
        recoverDocument
      },
      combos: { documentsTypes }
    } = this.props
    let buttonUpload, buttonNewSheet, buttonRecover, buttonSave, buttonValidate, iconReload, validatedText, buttonReject, buttonCancel, buttonDownload, editRecurrentEntityDocuments, commentDocument, buttonDelete
    if (this.props.docResult && this.props.docResult.buttonsPermission) {
      buttonUpload = this.props.docResult.buttonsPermission.buttonUpload
      buttonNewSheet = this.props.docResult.buttonsPermission.buttonNewSheet
      buttonRecover = this.props.docResult.buttonsPermission.buttonRecover
      buttonSave = this.props.docResult.buttonsPermission.buttonSave
      buttonValidate = this.props.docResult.buttonsPermission.buttonValidate
      iconReload = this.props.docResult.buttonsPermission.iconReload
      validatedText = this.props.docResult.buttonsPermission.validatedText
      buttonReject = this.props.docResult.buttonsPermission.buttonReject
      buttonCancel = this.props.docResult.buttonsPermission.buttonCancel
      buttonDownload = this.props.docResult.buttonsPermission.buttonDownload
      editRecurrentEntityDocuments = this.props.docResult.buttonsPermission.editRecurrentEntityDocuments
      commentDocument = this.props.docResult.buttonsPermission.commentDocument
      buttonDelete = this.props.docResult.buttonsPermission.buttonDelete
    } else {
      buttonUpload = buttonNewSheet = buttonRecover = buttonSave = buttonValidate = iconReload = validatedText = buttonReject = buttonCancel = buttonDownload = commentDocument = false
    }

    const tKey = 'DOSSIER_COMPONENTS.DOCUMENTARY_MANAGEMENT.ADD_OR_EDIT_DOCUMENT.'
    const statusTooltip = (<Tooltip id="statusTooltip">{documentStatusId && t(`DOSSIER_COMPONENTS.DOCUMENTARY_MANAGEMENT.${translateDocumentStatus[documentStatusId]}`)}</Tooltip>)
    const viewSheetTooltip = (<Tooltip id="viewTooltip">{t(`${tKey}VIEW_SHEET_BTN`)}</Tooltip>)
    const downloadTooltip = (<Tooltip id="downloadTooltip">{t(`${tKey}DOWNLOAD_BTN`)}</Tooltip>)
    const copyValuesTooltip = (<Tooltip id="copyValuesTooltip">{t(`${tKey}COPY_VALUES`)}</Tooltip>)
    const deleteSheetTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE_SHEET_BTN`)}</Tooltip>)
    const acceptFilesDropzone = getAccepFiles(this.props.documentTypeUseId)
    const maxSizeFilesDropzone = 10240000
    const editTooltip = (<Tooltip id="editTooltip">{t('DOSSIER_COMPONENTS.VEHICLE.TOOLTIP_VALIDATE_LICENSE_PLATE')}</Tooltip>)

    const canBeAddedInHistorical = buttonUpload
    const permissionToEdit = data && data.entity && (data.entity.entityTypeId === entityTypes.recurrentEntity && typeObject === 1 ? editRecurrentEntityDocuments : canBeAddedInHistorical)

    return (
      <Modal show={showDocumentEditionModal} className="_vModal_2 document-edition-modal customScrollbar" onHide={() => this.closeModal()}>
        <Modal.Header closeButton className='m-Header'>
          {documentStatusId && (
            <OverlayTrigger placement="right" overlay={statusTooltip}>
              <i id="documentStatus" className={'icono-heder-modal ico-document-' + documentStatusClass[translateDocumentStatus[documentStatusId]]}/>
            </OverlayTrigger>
          )}
          <h2 id="documentTitle" ref={this.documentTitleElementRef} className={'document-title' + (!this.state.showTitle ? ' invisible' : '')}>{this.state.documentTitle}</h2>
          {incorporationDate &&
            <div className="number-exp">
              <OverlayTrigger placement="right" overlay={<Tooltip id="001">{t(`${tKey}INCORPORATION_DATE`)}</Tooltip>}>
                <i className="iDocIcon-date-range-create"></i>
              </OverlayTrigger>
              <span className="incorporation-date">{incorporationDate}</span>
            </div>
          }
        </Modal.Header>
        <Modal.Body className='m-Body'>
          {(!this.state.showFileUploader) && (
            <div className='m-Body-Left'>

              <div className={'m-data-block ' + (this.state.dossierDataGroupDATAOpen ? 'unColapse' : 'colapse')}>
                <div className='data-block-header' onClick={() => this.toggleDossierDataGroup('DATA')} >
                  <div className='data-block-header-name'>
                    <span>{t(`${tKey}INFORMATION`)}</span>
                  </div>
                  <div className='data-block-header-actions'>
                    <i className="iDocIcon-caret-right-solid"></i>
                  </div>
                </div>
                <div className='data-block-body'>
                  { typeObject === 1 && ( // ENTITY
                    <>
                      {data?.entity.entityType && <PopoverItem itemType={'ent-1'} placement='right' data={data?.entity.entityType }></PopoverItem>}
                      {data?.entity.entityName && <PopoverItem itemType={'ent-2'} placement='right' data={data?.entity.entityName }></PopoverItem>}
                      {data?.entity.entityCifNif && <PopoverItem itemType={'ent-6'} placement='right' data={data?.entity.entityCifNif }></PopoverItem>}
                      {data?.entity.clientNumber && <PopoverItem itemType={'ent-5'} placement='right' data={data?.entity.clientNumber }></PopoverItem>}
                      {data?.entity.entityAddress && <PopoverItem itemType={'ent-7'} placement='right' data={data?.entity.entityAddress }></PopoverItem>}
                      {data?.entity.entityPhone && <PopoverItem itemType={'ent-8'} placement='right' data={data?.entity.entityPhone}></PopoverItem>}
                      {data?.entity.entityMail && <PopoverItem itemType={'ent-9'} placement='right' data={data?.entity.entityMail }></PopoverItem>}
                      <div className='popover-item dossierList'>
                        <DossierListPopover
                          t={t}
                          idx="exp-asociados1"
                          id={'popover-dossier-list'}
                          alive={data.lives}
                          stored={data.stored}
                          itemOverlayPlacement={'right'}
                        />
                      </div>
                    </>
                  )}
                  { typeObject === 2 && ( // VEHICLE
                    <>
                      {data?.vehicle.vehicleBrand && <PopoverItem itemType={'veh_06'} placement='right' data={data?.vehicle.vehicleBrand }></PopoverItem>}
                      {data?.vehicle.carline && <PopoverItem itemType={'veh_02'} placement='right' data={data?.vehicle.carline }></PopoverItem>}
                      {data?.vehicle.catalogue && <PopoverItem itemType={'veh_03'} placement='right' data={data?.vehicle.catalogue }></PopoverItem>}
                      {data?.vehicle.modelYear && <PopoverItem itemType={'veh_04'} placement='right' data={data?.vehicle.modelYear }></PopoverItem>}
                      {data?.vehicle.vehicleModel && <PopoverItem itemType={'veh_05'} placement='right' data={data?.vehicle.vehicleModel }></PopoverItem>}
                      {data?.vehicle.vehicleVinChassis && <PopoverItem itemType={'veh_12'} placement='right' data={data?.vehicle.vehicleVinChassis }></PopoverItem>}
                      {data?.vehicle.vehicleLicensePlate && <PopoverItem itemType={'veh_07'} placement='right' data={data?.vehicle.vehicleLicensePlate }></PopoverItem>}
                      {data?.vehicle.comercialCode && <PopoverItem itemType={'veh_08'} placement='right' data={data?.vehicle.comercialCode }></PopoverItem>}
                      {data?.vehicle.licensePlateDate && <PopoverItem itemType={'veh_09'} placement='right' data={data?.vehicle.licensePlateDate }></PopoverItem>}
                      {data?.vehicle.color && <PopoverItem itemType={'veh_10'} placement='right' data={data?.vehicle.color }></PopoverItem>}
                      {data?.vehicle.tapestry && <PopoverItem itemType={'veh_11'} placement='right' data={data?.vehicle.tapestry }></PopoverItem>}
                      <div className='popover-item dossierList'>
                        <DossierListPopover
                          t={t}
                          idx="exp-asociados1"
                          id={'popover-dossier-list'}
                          alive={data.lives}
                          stored={data.stored}
                          itemOverlayPlacement={'right'}
                        />
                      </div>
                    </>
                  )}
                  { typeObject === 3 && ( // DOSSIER
                    <>
                      {data.dossier.subtype && <PopoverItem itemType={'doss_02'} placement='right' data={data?.dossier.subtype }></PopoverItem>}
                      {data?.dossier.stage && <PopoverItem itemType={'doss_03'} placement='right' data={data?.dossier.stage }></PopoverItem>}
                      {data?.dossier.organizedUnit && <PopoverItem itemType={'doss_04'} placement='right' data={data?.dossier.organizedUnit }></PopoverItem>}
                      {data?.dossier.salesman && <PopoverItem itemType={'doss_05'} placement='right' data={data?.dossier.salesman }></PopoverItem>}
                      {data?.vehicle.licensePlateDate && <PopoverItem itemType={'veh_09'} placement='right' data={data?.vehicle.licensePlateDate }></PopoverItem>}
                      {data?.entity.entityType && <PopoverItem itemType={'ent-1'} placement='right' data={data?.entity.entityType }></PopoverItem>}
                      {data?.entity.entityName && <PopoverItem itemType={'ent-2'} placement='right' data={data?.entity.entityName }></PopoverItem>}
                      {data?.entity.clientNumber && <PopoverItem itemType={'ent-5'} placement='right' data={data?.entity.clientNumber }></PopoverItem>}
                      {data?.entity.entityCifNif && <PopoverItem itemType={'ent-6'} placement='right' data={data?.entity.entityCifNif }></PopoverItem>}
                      {data?.entity.entityPhone && <PopoverItem itemType={'ent-8'} placement='right' data={data?.entity.entityPhone }></PopoverItem>}
                      {data?.entity.entityMail && <PopoverItem itemType={'ent-9'} placement='right' data={data?.entity.entityMail }></PopoverItem>}
                      {data?.vehicle?.vehicleModel && <PopoverItem itemType={'veh_05'} placement='right' data={data?.vehicle.vehicleModel }></PopoverItem>}
                      {data?.vehicle?.vehicleVinChassis && <PopoverItem itemType={'veh_12'} placement='right' data={data?.vehicle.vehicleVinChassis }></PopoverItem>}
                      {data?.vehicle?.vehicleLicensePlate && <PopoverItem itemType={'veh_07'} placement='right' data={data?.vehicle.vehicleLicensePlate }></PopoverItem>}
                    </>
                  )}
                </div>
              </div>

              <div className={'m-data-block ' + (this.state.dossierDataGroupFILESOpen ? 'unColapse' : 'colapse')}>
                <div className='data-block-header' onClick={() => this.toggleDossierDataGroup('FILES')} >
                  <div className='data-block-header-name'>
                    <span>{t(`${tKey}FILES`)}</span>
                  </div>
                  <div className='data-block-header-actions'>
                    <i className="iDocIcon-caret-right-solid"></i>
                  </div>
                </div>
                <div className='data-block-body'>
                  <>
                    {numPages && (
                      <div className={(activeSheet === 0) ? 'fileCard selected' : 'fileCard'} key={'0.1'} onClick={() => this.selectDocument(0, 1)}>
                        <div className='fileCard-status'><i className="iDocIcon-file-document"/></div>
                        <div className='fileCard-Name'>
                          <div className='fileCard-miniature' style={{ backgroundImage: 'url(' + `${settings.url}documentHistorical/${documentId}/preview?token=${token}&pageId=${1}&fecha=${this.state.parametroFecha}` + ')' }}></div>
                          <p>
                            <span className='fileCard-fileCount'>{/* documentId */}{t(`${tKey}SHEETS_TABLE.FILE`) + ' 1 ' + t(`${tKey}SHEETS_TABLE.DE`) + ' ' + (sheets.length + 1)}</span>
                            <span className='fileCard-fileDateText'>{t(`${tKey}SHEETS_TABLE.CREATION_DATE`)}</span>
                            <span className='fileCard-fileDate'>{this.props.docResult.incorporationDate}</span>
                          </p>
                        </div>
                        {buttonDelete && sheets.length > 0 && (
                          <OverlayTrigger placement="top" overlay={deleteSheetTooltip}>
                            <div
                              className='fileCard-delete'
                              onClick={(documentId) => {
                                this.deleteDocumentSheet(documentId, activeSheet, organizedUnitId)
                                this.props.trackAction(this.factoryDeleteSheetAction(documentId))
                              }} id="btn_delete_document_sheet">
                              <i className="iDocIcon-delete-forever"/>
                            </div>
                          </OverlayTrigger>
                        )}
                        <i className="selectedArrow iDocIcon-caret-right-solid"/>
                      </div>
                    )}
                    {sheets.map((sheet, idx) => {
                      return (

                        <div id={idx} className={(activeSheet === sheet.id) ? 'fileCard selected' : 'fileCard'} key={sheet.id + '.1'} onClick={() => this.selectDocument(sheet.id, 1)}>
                          <div className='fileCard-status'><i className="iDocIcon-file-document"/></div>
                          <div className='fileCard-Name'>
                            <div className='fileCard-miniature' style={{ backgroundImage: 'url(' + `${settings.url}documentHistorical/${documentId}/preview?token=${token}&pageId=${1}&fecha=${this.state.parametroFecha}` + ')' }}></div>
                            <p>
                              <span className='fileCard-fileCount'>{/* documentId */}{t(`${tKey}SHEETS_TABLE.FILE`) + ' ' + (idx + 2) + ' ' + t(`${tKey}SHEETS_TABLE.DE`) + ' ' + (sheets.length + 1)}</span>
                              <span className='fileCard-fileDateText'>{t(`${tKey}SHEETS_TABLE.CREATION_DATE`)}</span>
                              <span className='fileCard-fileDate'>{sheet.creationDate}</span>
                            </p>
                          </div>
                          {buttonDelete && sheets.length > 0 && (
                            <OverlayTrigger placement="top" overlay={deleteSheetTooltip}>
                              <div
                                className='fileCard-delete'
                                onClick={(documentId) => {
                                  this.deleteDocumentSheet(documentId, activeSheet, organizedUnitId)
                                  this.props.trackAction(this.factoryDeleteSheetAction(documentId))
                                }} id="btn_delete_document_sheet">
                                <i className="iDocIcon-delete-forever"/>
                              </div>
                            </OverlayTrigger>
                          )}
                          <i className="selectedArrow iDocIcon-caret-right-solid"/>
                        </div>

                      )
                    })}
                    { buttonNewSheet && (this.props.fleetMode === null || this.props.fleetMode === undefined) && (
                      <div className="fileCard">
                        <div className={'box-add-sheet dropzone-box-wrapper-modal' + (this.state.hasInvalidFile ? ' has-error' : '')}>
                          { <DropZone
                            id="dropZone"
                            multiple={false}
                            onDrop={(acceptedFiles, rejectedFiles) => this.onDrop(acceptedFiles, rejectedFiles, organizedUnitId)}
                            accept={acceptFilesDropzone}
                            maxSize={maxSizeFilesDropzone}
                            style={{ height: '100%' }}
                            className={this.state.dropzonePanelActive ? 'active' : ''}
                            onDragEnter={() => this.onDragEnter(true)}
                            onDragLeave={() => this.onDragLeave(true)}
                          >
                            {({ getRootProps, getInputProps }) => (
                              <div className="text-wrapper" {...getRootProps()}>
                                <input {...getInputProps()} />
                                <i className="ico-cloud"/>
                                <p>
                                  {t(`${tKey}DROP_FILES_FULL`)}
                                  <br/>
                                  {this.state.hasInvalidFile && (
                                    <span className="help-block text-center">
                                      {t(`${tKey}VALIDATION.FILE`)}
                                    </span>
                                  )}
                                </p>
                              </div>
                            )}
                          </DropZone>}
                        </div>
                      </div>
                    )
                    }
                  </>
                </div>
              </div>

            </div>
          )}

          <div className='m-Body-Center'>
            { !this.state.showFileUploader && (
              <div className="imageActions">
                <OverlayTrigger placement="bottom" overlay={viewSheetTooltip}>
                  <Button className="_Btn accept stk o-icn" onClick={(e) => activeSheet === 0 ? (this.toggleFullScreenDocumentModal(e)) : (this.toggleFullScreenDocumentSheetModal(e, activeSheet))}>
                    <i className="iDocIcon-search"/>
                  </Button>
                </OverlayTrigger>
                {buttonDownload && (
                  <OverlayTrigger placement="right" overlay={downloadTooltip}>
                    <Button className="_Btn accept stk o-icn" onClick={(e) => activeSheet === 0 ? (this.downloadDocument(e)) : (this.downloadDocumentSheet(e, activeSheet))}>
                      <i className='iDocIcon-cloud-download-alt-solid'/>
                    </Button>
                  </OverlayTrigger>
                )}
              </div>
            )}
            <div className='imageConteiner'>
              <div className='imageSelected'>
                <div className={'dropzone-wrapper-modal' + (this.state.hasInvalidFile || this.state.showMissingDocumentTypeError ? ' has-error' : '')} style={{ height: '100%' }}>
                  {
                    iconReload
                      ? (
                        <div onClick={() => openDocumentEditionModal(documentId, documentTypeUseId, documentParentTypeId, dossierId, entityId, vehicleId, organizedUnitId, null, callback, refreshAfterChange, dossierType, null, null, null, null, null, readOnlyFields)} className="text-wrapper">
                          <img src="images/check_list.gif" alt="" />
                          <h2>{t(`${tKey}LOADING_MESSAGE`)}</h2>
                          <p>{t(`${tKey}TRY_FETCH_DOCUMENT`)}</p>
                        </div>
                      ) : (
                        !this.state.showFileUploader ? (
                          <div id="dropZone" className="dropzone-thumbnail" style={{ height: '100%' }}>
                            {this.props.isLoading ? (
                              <div style={{ height: '100%', border: '1px solid #b1b1b1', paddingTop: '30%' }}>
                                <SmallLoaderPage
                                  background="#ffffff"
                                />
                              </div>
                            ) : (
                              <>
                                <div className="dropzone-img-wrapper" style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  {
                                    this.state.zoomProps.img !== '' && (
                                      <ImageZoom
                                        src={this.state.zoomProps.img}
                                        width={this.state.zoomProps.width}
                                        height={this.state.zoomProps.height}
                                        magnifierSize={300}
                                        zoomLevel={2}
                                        enabled={true}
                                      />
                                    )
                                  }
                                </div>
                              </>
                            )}
                          </div>
                        ) : buttonUpload && (
                          <DropZone
                            id="dropZone"
                            multiple={false}
                            onDrop={(acceptedFiles, rejectedFiles) => this.onDrop(acceptedFiles, rejectedFiles, organizedUnitId)}
                            disabled={(!this.state.selectedDocType && !documentTypeUseName) || !permissionToEdit}
                            accept={acceptFilesDropzone}
                            maxSize={maxSizeFilesDropzone}
                            style={{ height: '100%' }}
                            className={this.state.dropzoneActive ? 'active' : 'unactive'}
                            onDragEnter={() => this.onDragEnter(false)}
                            onDragLeave={() => this.onDragLeave(false)}
                          >
                            {({ getRootProps, getInputProps }) => (
                              <div className="text-wrapper modal-subir-fichero-inicio" {...getRootProps()}>
                                <input {...getInputProps()} />
                                <div onClick={() => { if (!this.state.selectedDocType && !documentTypeUseName) this.setState({ showMissingDocumentTypeError: true }) }}>
                                  <i className={!documentTypeUseName ? 'ico-cloud cloud-apagado' : 'ico-cloud cloud-size'} />
                                  {!this.state.showMissingDocumentTypeError ? [
                                    <h2 key="dropZone-title">{t(`${tKey}DROP_FILES`)}</h2>,
                                    <p key="dropZone-subtitle">{t(`${tKey}SELECT_FILES`)}</p>,
                                    this.state.hasInvalidFile && <div className="help-block text-center" key="dropZone-help-block">{t(`${tKey}VALIDATION.FILE`)}</div>
                                  ] : (
                                    <h2>{t(`${tKey}VALIDATION.DOCUMENT_TYPE_REQUIRED`)}</h2>
                                  )}
                                </div>
                              </div>
                            )}
                          </DropZone>
                        )
                      )
                  }
                </div>
              </div>
              <div className='inameMiniature'>
                {(!this.state.showFileUploader && documentId) && (
                  <div className={'carrusel-imagenes-modal ' + (buttonDownload ? 'with-download ' : '') + (numPages > this.state.carouselItemsPerPage ? '' : 'without-pagination ') + (this.state.showPageCarrusel ? '' : 'hide-page-carousel')}>
                    <div className="vertical-scroll-wrapper squares">
                      {activeSheet === 0 && numPages && (
                        (() => {
                          const pages = []
                          if (settings.clientFieldValidation !== 'toyo') {
                            const initItem = this.state.carouselPaginationIdx > 1 ? (this.state.carouselPaginationIdx - 1) * this.state.carouselItemsPerPage + 1 : 1
                            let lastItem = this.state.carouselPaginationIdx ? (initItem > 1 ? initItem + this.state.carouselItemsPerPage - 1 : this.state.carouselItemsPerPage) : numPages

                            if (lastItem > numPages) {
                              lastItem = numPages
                            }
                            for (let i = initItem; i <= lastItem; i++) {
                              pages.push(
                                <div key={'0.' + i} className="img-carrusel" onClick={() => this.setActivePage(0, i)}>
                                  <ImgPage
                                    src={`${settings.url}documentHistorical/${documentId}/preview?token=${token}&pageId=${i}&fecha=${this.state.parametroFecha}`}
                                    active={(this.props.activeSheet === 0 && this.props.activePage === i) ? 'img-active' : ''}
                                  />
                                </div>
                              )
                            }
                          }
                          return pages
                        })()
                      )}
                      {activeSheet !== 0 && (sheets.length > 0 || this.state.showSheets) && (
                        (() => {
                          const activeSheetIdx = sheets.findIndex((sheet, idx) => {
                            return activeSheet === sheet.id
                          })
                          const pages = []
                          if (settings.clientFieldValidation !== 'toyo') {
                            if (activeSheetIdx !== -1) {
                              const activeSheet = sheets[activeSheetIdx]
                              const initItem = this.state.carouselPaginationIdx > 1 ? (this.state.carouselPaginationIdx - 1) * this.state.carouselItemsPerPage + 1 : 1
                              let lastItem = this.state.carouselPaginationIdx ? (initItem > 1 ? initItem + this.state.carouselItemsPerPage - 1 : this.state.carouselItemsPerPage) : activeSheet.numPages

                              if (lastItem > activeSheet.numPages) {
                                lastItem = activeSheet.numPages
                              }
                              for (let i = initItem; i <= lastItem; i++) {
                                pages.push(
                                  <div key={activeSheet.id + '.' + i} className="img-carrusel" onClick={() => this.setActivePage(activeSheet.id, i)}>
                                    <ImgPage
                                      src={`${settings.url}documentHistorical/${documentId}/sheet/${activeSheet.id}/preview?token=${token}&pageId=${i}&fecha=${this.state.parametroFecha}`}
                                      active={(this.props.activeSheet === activeSheet.id && this.props.activePage === i) ? 'img-active' : ''}
                                    />
                                  </div>
                                )
                              }
                            }
                          }
                          return pages
                        })()
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className='m-Body-Right'>
            <Form autoComplete="off" className='full-height' onSubmit={handleSubmit(values => {
              this.changeAll(values)
              this.submitDocument(values)
            })}>
              <div className='m-Body-Right-Fields'>
                {/** DOCUMENT TYPE BLOCK */}
                { !documentTypeUseName && this.state.showFileUploader &&
                  <Field
                    component={InputSelect}
                    colWidth={100} // 25, 33, 50, 75, 100 default=25
                    controlLabel={t(`${tKey}DOCUMENT_TYPE`)}
                    id="documentType"
                    name="documentType"
                    placeholder={t(`${tKey}DOCUMENT_TYPE`)}
                    menuContainerStyle={{ zIndex: 999 }}
                    options={documentsTypes}
                    onInputChange={(value) => this.handleDocTypeChange(value)}
                    valueKey="id"
                    labelKey="value"
                    disabled={!!thumbnail}
                    customClass="select-document-management"
                  />
                }
                {/** REJECTED BLOCK */}
                { this.props.docResult.documentStatusId !== backEndIdDocumentStatus.REJECTED && commentDocument && (
                  <div className={'m-data-block rejected'}>
                    <div className='data-block-header'>
                      <div className='data-block-header-name'>
                        <span>{t(`${tKey}TEXT`)}</span>
                      </div>
                    </div>
                    <div className='data-block-body'>
                      <div className='fieldsContainer'>
                        {/** REJECTED FIELDS */}
                        <Field
                          component={InputText}
                          colWidth={100} // 25, 33, 50, 75, 100 default=25
                          id='comment'
                          name='comment'
                          componentClass="textarea"
                          colSm={12}
                          placeholder={t(`${tKey}TEXT`)}
                          customClass="comment-reject-modal-textarea"
                          textAlign="left"
                          paddingLeft={{ paddingLeft: '0px' }}
                          disabled={(!(documentId && !validatedText))}
                        />
                        {/** REJECTED FIELDS */}
                      </div>
                    </div>
                  </div>
                )}

                { this.props.docResult.documentStatusId === backEndIdDocumentStatus.REJECTED && comment && (
                  <div className={'m-data-block rejected'}>
                    <div className='data-block-header'>
                      <div className='data-block-header-name'>
                        <span>{t(`${tKey}TEXT`)}</span>
                      </div>
                    </div>
                    <div className='data-block-body'>
                      <div className='fieldsContainer'>
                        {/** REJECTED FIELDS */}
                        <SimpleInputText
                          colWidth={100} // 25, 33, 50, 75, 100 default=25
                          controlLabel={t(`${tKey}REJECT_REASON`)}
                          id='comment'
                          name='comment'
                          value={comment}
                          disabled={true}
                          componentClass="textarea"
                        />
                        {/** REJECTED FIELDS */}
                      </div>
                    </div>
                  </div>
                )}

                {/** END REJECTED BLOCK */}

                {/** METADATA BLOCK */}
                { typeView && typeView === typeViewConstant.entityValues && fields.length && (
                  <div className={'m-data-block ' + (this.state.dossierDataGroupMETAOpen ? 'unColapse' : 'colapse')}>
                    <div className='data-block-header' onClick={() => this.toggleDossierDataGroup('META')} >
                      <div className='data-block-header-name'>
                        <span>{t(`${tKey}METADATA`)}</span>
                      </div>
                      <div className='data-block-header-actions'>
                        <i className="iDocIcon-caret-right-solid"></i>
                      </div>
                    </div>
                    <div className='data-block-body'>
                      {/** METADATA FIELDS */}
                      { typeView === typeViewConstant.entityValues ? ([
                        <div key="metadata" className="fieldsContainer">

                          {
                            fields.map((field, idx) => (
                              <SimpleInputText
                                key={idx}
                                colWidth={100} // 25, 33, 50, 75, 100 default=25
                                id={'metadata-' + field.code}
                                value={field.metaValue ? field.metaValue : ''}
                                controlLabel={field.name}
                                disabled={true}
                                paddingLeft={{ paddingLeft: '0px' }}
                              />
                            )
                            )
                          }
                        </div>,
                        <div key="copy" className="columna-boton-copiar">
                          <OverlayTrigger placement="top" overlay={copyValuesTooltip}>
                            <Button className="_Btn accent stk o-icn" onClick={() => this.copyMetaToEntityValues()}>
                              <i className='iDocIcon-copy-clone'/>
                            </Button>
                          </OverlayTrigger>
                        </div>
                      ]) : null
                      }
                    </div>
                  </div>
                )}
                {/** END METADATA BLOCK */}

                {/** FIELDS BLOCK */}
                { typeView && typeView !== typeViewConstant.empty && (
                  <div className={'m-data-block ' + (this.state.dossierDataGroupFIELSSOpen ? 'unColapse' : 'colapse')}>
                    <div className='data-block-header' onClick={() => this.toggleDossierDataGroup('FIELS')} >
                      <div className='data-block-header-name'>
                        <span>{t(`${tKey}DATA_TO_FILL`)}</span>
                      </div>
                      <div className='data-block-header-actions'>
                        <i className="iDocIcon-caret-right-solid"></i>
                      </div>
                    </div>
                    <div className='data-block-body'>
                      {/** FIELDS */}
                      <div className='fieldsContainer dossier-Component'>
                        {
                          fields.map((field, idx) => (
                            <div key={idx}>
                              {(() => {
                                switch (field.typeField) {
                                  case typeFieldsConstant.number:
                                    return (
                                      <Field
                                        component={InputNatural}
                                        colWidth={100} // 25, 33, 50, 75, 100 default=25 colSm={6}
                                        controlLabel={field.name}
                                        id={field.code}
                                        name={'entityValue.' + field.fieldId}
                                        disabled={(!(documentId && !validatedText)) || !permissionToEdit}
                                        textAlign="right"
                                        paddingLeft={{ paddingLeft: '0px' }}
                                      />
                                    )
                                  case typeFieldsConstant.money:
                                    return (
                                      <Field
                                        component={InputMoney}
                                        colWidth={100} // 25, 33, 50, 75, 100 default=25
                                        controlLabel={field.name}
                                        id={field.code}
                                        name={'entityValue.' + field.fieldId}
                                        disabled={(!(documentId && !validatedText)) || !permissionToEdit}
                                        textAlign="right"
                                        paddingLeft={{ paddingLeft: '0px' }}
                                      />
                                    )
                                  case typeFieldsConstant.decimal:
                                    return (
                                      <Field
                                        component={InputNatural}
                                        colWidth={100} // 25, 33, 50, 75, 100 default=25
                                        controlLabel={field.name}
                                        id={field.code}
                                        name={'entityValue.' + field.fieldId}
                                        disabled={(!(documentId && !validatedText)) || !permissionToEdit}
                                        textAlign="right"
                                        paddingLeft={{ paddingLeft: '0px' }}
                                      />
                                    )
                                  case typeFieldsConstant.date:
                                    return (
                                      <Field
                                        component={InputDatePicker}
                                        colWidth={100} // 25, 33, 50, 75, 100 default=25
                                        controlLabel={field.name}
                                        id={field.code}
                                        name={'entityValue.' + field.fieldId}
                                        validate={(value, allValues, props) => {
                                          let result = validateDate(value, props)
                                          if (result === Object(result) && field.customValidations) {
                                            result = customValidations(field.customValidations, value, props)
                                          }
                                          return result === Object(result) ? undefined : result
                                        }}
                                        disabled={(!(documentId && !validatedText)) || !permissionToEdit}
                                        paddingLeft={{ paddingLeft: '0px' }}
                                      />
                                    )
                                  case typeFieldsConstant.dateTime:
                                    return (
                                      <Field
                                        component={InputDateTimePicker}
                                        colWidth={100} // 25, 33, 50, 75, 100 default=25
                                        controlLabel={field.name}
                                        id={field.code}
                                        name={'entityValue.' + field.fieldId}
                                        disabled={(!(documentId && !validatedText)) || !permissionToEdit}
                                        paddingLeft={{ paddingLeft: '0px' }}
                                      />
                                    )
                                  case typeFieldsConstant.list:
                                    return (
                                      <Field
                                        component={InputSelect}
                                        colWidth={100} // 25, 33, 50, 75, 100 default=25
                                        controlLabel={field.name}
                                        id={field.code}
                                        name={'entityValue.' + field.fieldId}
                                        placeholder={field.name}
                                        options={field.options}
                                        valueKey="id"
                                        labelKey="value"
                                        disabled={(!(documentId && !validatedText)) || !permissionToEdit}
                                        paddingLeft={{ paddingLeft: '0px' }}
                                        key="select-document"
                                      />)
                                  case typeFieldsConstant.licensePlate:
                                    return (
                                      <Field
                                        component={InputText}
                                        colWidth={100} // 25, 33, 50, 75, 100 default=25
                                        controlLabel={field.name}
                                        id={field.code}
                                        name={'entityValue.' + field.fieldId}
                                        placeholder={field.name}
                                        normalize={value => multipleNormalize(value, [toUpperCase, trimAll])}
                                        disabled={(!(documentId && !validatedText)) || !permissionToEdit}
                                        textAlign="left"
                                        paddingLeft={{ paddingLeft: '0px' }}
                                      />)
                                  case typeFieldsConstant.vinChassis:
                                    return (
                                      <Field
                                        component={InputText}
                                        colWidth={100} // 25, 33, 50, 75, 100 default=25
                                        maxLength={17}
                                        controlLabel={field.name}
                                        id={field.code}
                                        name={'entityValue.' + field.fieldId}
                                        placeholder={field.name}
                                        normalize={value => multipleNormalize(value, [toUpperCase, trimAll])}
                                        disabled={(!(documentId && !validatedText)) || !permissionToEdit}
                                        textAlign="left"
                                        paddingLeft={{ paddingLeft: '0px' }}
                                      />
                                    )
                                  case typeFieldsConstant.licensePlateValidation:
                                    return ([
                                      <Field
                                        component={InputCheckBox}
                                        colWidth={100} // 25, 33, 50, 75, 100 default=25
                                        customClass="disable-license-plate-checkbox"
                                        controlLabel={field.name}
                                        id={field.code}
                                        tooltip={editTooltip}
                                        tooltipPosition='left'
                                        name={'entityValue.' + field.fieldId}
                                        key={'entityValue.' + field.fieldId}
                                        placeholder={field.name}
                                        disabled= {(!(documentId && !validatedText) || field.isReadOnly) || !permissionToEdit || documentId === null || (!buttonValidate && !buttonSave)}
                                      />
                                    ])
                                  default:
                                    return (
                                      <Field
                                        component={InputText}
                                        colWidth={100} // 25, 33, 50, 75, 100 default=25
                                        controlLabel={field.name}
                                        id={field.code}
                                        name={'entityValue.' + field.fieldId}
                                        placeholder={field.name}
                                        disabled={(!(documentId && !validatedText)) || !permissionToEdit}
                                        textAlign="left"
                                        paddingLeft={{ paddingLeft: '0px' }}
                                      />
                                    )
                                }
                              })()}
                            </div>
                          ))
                        }
                      </div>

                    </div>
                    {/* <Col sm={typeView === typeViewConstant.entityValues ? (5) : (12)} className={typeView === typeViewConstant.entityValues ? ('columna-datos-rellenar') : ('modal-columna-centrada')}>
                      <Row className="row-modal"><h3 style={{ fontSize: '13px' }}>{t(`${tKey}DATA_TO_FILL`)}</h3></Row>
                      <Row className="row-modal">

                      </Row>
                    </Col> */}
                  </div>
                )}
                {/** END FIELDS BLOCK */}

              </div>

              <div className='m-Body-Right-Actions'>
                <div className='m-data-block actions '>
                  <div className='data-block-header' onClick={() => this.toggleDossierDataGroup('ACTIONS')} >
                    <div className='data-block-header-name'>
                      <span>{t(`${tKey}ACTIONS`)}</span>
                    </div>
                  </div>
                  <div className='data-block-body'>
                    <div className='btnContainer'>
                      { !this.state.showFileUploader && (
                        <>
                          {/* ACTIONS BUTTONS HERE */}
                          { buttonValidate && permissionToEdit ? [
                            <Button
                              id="btn_validate"
                              key="btn_validate"
                              className="_Btn new stk"
                              onClick={handleSubmit(values => {
                                this.changeAll(values)
                                this.submitDocument({ ...values, validateAction: true })
                              })}
                            >
                              <i className="ico-check" /> {t(`${tKey}VALIDATE_BTN`)}
                            </Button>,
                            buttonReject && (
                              <Button
                                id="btn_reject"
                                key="btn_reject"
                                className="_Btn cancel stk"
                                onClick={() => this.setState({ showRejectCommentModal: true })}
                              ><i className="ico-cancel" /> {t(`${tKey}REJECT_BTN`)}</Button>
                            ),
                            (settings.showSignDocumentButton && dossierType === dossierTypesConstant.sales && dossierSubType === dossierSubTypeIdConstants.venta_vn && documentTypeUseId === 4) && (// Recibo de paga y señal
                              <Button
                                id="btn_sign"
                                key="btn_sign"
                                className="_Btn accent"
                                onClick={() => {
                                  this.props.trackAction(this.factorySignRequestAction(documentId))
                                  const signAppUrl = `http://signidoccar.premm.es/?entorno=${encodeURIComponent(settings.url)}&token=${token}&checkListId=${checkListIdReciboPagaYSenal}&organizedUnitId=${organizedUnitId}&documentTypeId=${documentTypeUseId}&id=${dossierId}&documentId=${documentId}&fecha=${this.state.parametroFecha}`
                                  window.open(signAppUrl, '_blank')
                                }}
                              >
                                <i className="iDocIcon-signature-draw"></i>{t(`${tKey}SIGN_BTN`)}
                              </Button>
                            )
                          ] : null
                          }
                          { buttonSave && permissionToEdit ? (
                            <Button
                              id="btn_save"
                              className="_Btn new"
                              onClick={handleSubmit(values => {
                                this.changeAll(values)
                                this.submitDocument(values)
                              })}
                              type="submit">
                              {t(`${tKey}SAVE_BTN`)}
                            </Button>
                          ) : null
                          }
                          {
                            buttonRecover && permissionToEdit ? (
                              <Button
                                id="btn_recover"
                                className="_Btn accept"
                                onClick={() => recoverDocument(documentId, documentTypeUseId, documentParentTypeId, dossierId, entityId, vehicleId, organizedUnitId, null, callback, refreshAfterChange, dossierType)}
                              >{t(`${tKey}RECOVER`)}</Button>
                            ) : null
                          }
                          {
                            buttonCancel && permissionToEdit ? (
                              <Button
                                id="btn_cancel"
                                className="_Btn cancel"
                                onClick={() => this.cancelDocument(dossierType, documentId, documentParentTypeId, dossierId)}
                              >{t(`${tKey}CANCEL`)}</Button>
                            ) : null
                          }
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>

            </Form>

          </div>
          <div className='m-Body-ModaldContainer'>
            {this.state.showRejectCommentModal && <RejectCommentModal
              t={t}
              showModal={this.state.showRejectCommentModal}
              actions={{
                rejectAction: this.rejectDocument,
                closeModal: () => this.setState({ showRejectCommentModal: false })
              }}
            />}
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

function validateFunction ({ entityValue = {} }, props) {
  const tKey = 'DOSSIER_COMPONENTS.DOCUMENTARY_MANAGEMENT.ADD_OR_EDIT_DOCUMENT.VALIDATION.'
  const error = { entityValue: {} }
  const { docResult: { fields = [] }, t } = props
  let aux
  fields.forEach(field => {
    if (field.customValidations && field.customValidations.indexOf('regEx-') !== -1) {
      aux = validateRegex(field.customValidations, field.name, entityValue[field.fieldId.toString()], props)
      if (aux !== Object(aux)) {
        error.entityValue[field.fieldId.toString()] = aux
      }
    }
    if (field.isMandatory && !entityValue[field.fieldId.toString()]) error.entityValue[field.fieldId.toString()] = t(`${tKey}MANDATORY`)
  })
  return error
}

var decoratedComponent = TrackingContainer(DocumentEdition, false)

export default reduxForm({
  form: 'AddOrEditHistoricalDocumentForm',
  validate: validateFunction,
  destroyOnUnmount: false
})(decoratedComponent)
